import React from 'react';
import PropTypes from 'prop-types';
import { Button, FormatCurrency } from 'day8-ui';
import { RxCross1 } from "@react-icons/all-files/rx/RxCross1";
import { RxCheck } from "@react-icons/all-files/rx/RxCheck";
import { FaCircleInfo } from '@react-icons/all-files/fa6/FaCircleInfo';
import { useToolipModal } from '../../../context/TooltipModalContext';

const PricingRow = ({
  label, price, currency, included, description, readMoreLink
}) => {
  const { openTooltipModal } = useToolipModal();
  return (
    <div className="dui-flex dui-justify-between dui-my-4 dui-gap-4">
      {!!description && (
        <Button
          buttonType='LINK_UNDERLINE'
          buttonSize="MEDIUM"
          rightIcon={<FaCircleInfo />}
          onClick={() => openTooltipModal({
            title: label,
            tooltipText: (
              <div>
                <p className='dui-inline-block'>{description}</p>
                {!!readMoreLink && (
                  <>
                    {' '}Read more{' '}
                    <a href={readMoreLink} className='dui-inline-block' target='_blank' rel="noopener noreferrer">
                      <Button className='!dui-inline-block' buttonType='LINK_UNDERLINE' buttonSize="MEDIUM">here.</Button>
                    </a>
                  </>
                )}
              </div>
            )
          })
          }
        >
          {label}
        </Button>
      )}
      {!description && <p className="dui-font-normal">{label}</p>}
      {/* <div><p className="dui-font-normal">{label}</p></div> */}
      <div className="dui-text-right dui-font-semibold">
        {included !== undefined ? (
          <>
            {included ? <RxCheck /> : <RxCross1 />}
          </>
        ) : (
          <span className=""><FormatCurrency amount={price} baseCurrency={currency} /></span>
        )}
      </div>
    </div>
  );
};
PricingRow.propTypes = {
  label: PropTypes.string,
  price: PropTypes.number,
  currency: PropTypes.string,
  included: PropTypes.bool
};

export default PricingRow;
